import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { BlockDocument, blocksPullQueryBuilder } from './queryBuilder';

export function blocksFamilyMember(
  configBuilder: ConfigBuilder,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<BlockDocument> {
  const syncConfig = configBuilder<BlockDocument>(RxdbCollectionNameV2.BLOCKS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, blocksPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  // Legacy sets the syncInterval to LiveInterval.MINUTES_15
  return create(RxdbCollectionNameV2.BLOCKS, replicationState, [sites]);
}
